<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00061.installation.programmation' | translate"
      [description]="
        'P00061.installation.programmation.description' | translate
      "
    >
    </app-header-configuration>

    <app-two-choices-control
      [title]="'P00061.installation.horloge' | translate"
      [firstLabel]="
        'P00039.lighting.functionality.parameters.setting.title.clock.day'
          | translate
      "
      [firstValue]="0"
      [secondLabel]="
        'P00039.lighting.functionality.parameters.setting.title.clock.week'
          | translate
      "
      [secondValue]="1"
      [value]="actionStack!.getValue('wpPTypeHorloge')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PACWP_Parametrage1,
          'wpPTypeHorloge',
          $event,
          null
        )
      "
    >
    </app-two-choices-control>

    @if (this.actionStack!.getValue('wpPTypeHorloge') === 0) {
      <app-larged-link
        [name]="
          'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
            | translate
        "
        (onPress)="goToFunctionParametersSettingsClockScreen()"
      >
      </app-larged-link>
    } @else {
      <app-larged-link
        [name]="
          'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
            | translate
        "
        (onPress)="goToFunctionParametersSettingClockWeekScreen()"
      >
      </app-larged-link>
    }

    <app-label-description
      [description]="'P00061.installation.horloge.description' | translate"
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
